import React from 'react';
import Select from 'react-select/async';
import Fuse from 'fuse.js';
import { useField } from 'formik';
import { ValidationMessage } from '../../../Helpers/validation/validationMessage';
import { getLabel } from '../../../Language/labels';

export const Search = ({ selectOptions, ...props }) => {

  const [, meta, helpers] = useField(props);

  const options = {
    includeScore: true,
    keys: ['label'],
    threshold: 0.2
  }

  const fuse = new Fuse(selectOptions, options)

  const doSearch = (searchTerm) => {
    const result = fuse.search(searchTerm);
    var results = result.map(e => e.item);
    if (searchTerm && searchTerm?.toLowerCase() !== 'other') {
      results.push({value: 0, label: 'Other'});
    }
    return results;
  }

  const searchOptions = (searchTerm) => {
    if (searchTerm.length > 3) {
      return new Promise((resolve) => {
        resolve(doSearch(searchTerm));
      })
    } else {
      return new Promise((resolve) => {
        resolve(() => []);
      })
    }
  }

  const onSelectChanged = ({ value }) => {
    helpers.setValue(parseInt(value, 10));
  }

  return (
    <>
      <Select className='react-select-container' classNamePrefix="react-select"
        defaultOptions={true} loadOptions={searchOptions} onChange={onSelectChanged} placeholder={getLabel('institutionPlaceholder')} />
      <ValidationMessage {...meta} />
    </>
  )
}